// AUTO-GENERATED - DO NOT EDIT MANUALLY

export enum BookingEventActionType {
	Email = 'email',
	Sms = 'sms',
	Webhook = 'webhook',
}

export enum BookingRuleType {
	Offer = 'offer',
	Product = 'product',
	Activity = 'activity',
	Session = 'session',
	ValidityDates = 'validity_dates',
	Pax = 'pax',
	Price = 'price',
	CustomerBookingCount = 'customer_booking_count',
}

export enum BillingPaymentStatus {
	Processing = 'processing',
	Succeeded = 'succeeded',
	RequiresAction = 'requires_action',
	RequiresCapture = 'requires_capture',
	RequiresConfirmation = 'requires_confirmation',
	RequiresPaymentMethod = 'requires_payment_method',
	Canceled = 'canceled',
	Failed = 'failed',
}

export enum BillingDisputeStatus {
	Open = 'open',
	Lost = 'lost',
	Won = 'won',
	Recovered = 'recovered',
}

export enum PaymentStatus {
	Success = 'success',
	Failed = 'failed',
	Processing = 'processing',
	Canceled = 'canceled',
	Expired = 'expired',
}

export enum PaymentMethod {
	Online = 'online',
	Pos = 'pos',
	Giftcard = 'giftcard',
	Package = 'package',
}

export enum BookingStatus {
	Booked = 'booked',
	ToBeConfirmed = 'to_be_confirmed',
	Confirmed = 'confirmed',
	ToBeReconfirmed = 'to_be_reconfirmed',
	Canceled = 'canceled',
	NoShow = 'no_show',
	Left = 'left',
	Intent = 'intent',
	ToBePaid = 'to_be_paid',
	Expired = 'expired',
}

export enum BookingOrigin {
	Widget = 'widget',
	App = 'app',
}

export enum GuaranteeStatus {
	Asking = 'asking',
	Guaranteed = 'guaranteed',
	Captured = 'captured',
	Failed = 'failed',
	Consumed = 'consumed',
	Cancelled = 'cancelled',
}

export enum AgendaTitleDisplay {
	Customer = 'customer',
	SessionName = 'sessionName',
}

export enum AgendaPaxDisplay {
	Remaining = 'remaining',
	Current = 'current',
	CurrentAndCapacity = 'currentAndCapacity',
	Hidden = 'hidden',
}

export enum AgendaShowTimeslot {
	All = 'all',
	Start = 'start',
	End = 'end',
	Hidden = 'hidden',
}

export enum AgendaThirdRowDisplay {
	PrivateNote = 'privateNote',
	CustomerRequest = 'customerRequest',
	Hidden = 'hidden',
}

export enum AgendaBackground {
	Customer = 'customer',
	Session = 'session',
	Booking = 'booking',
	Offer = 'offer',
	None = '',
}

export enum AgendaCashDisplay {
	Remaining = 'remaining',
	Total = 'total',
	None = '',
}

export enum AgendaBookingPreviewDisplay {
	Right = 'right',
	Left = 'left',
	Bottom = 'bottom',
}

export enum BillingInvoiceType {
	Subscription = 'subscription',
	Sms = 'sms',
	MonthlyFee = 'monthly_fee',
}

export enum BillingInvoiceStatus {
	Open = 'open',
	Paid = 'paid',
	Void = 'void',
	Uncollectible = 'uncollectible',
}

export enum PaymentObjectType {
	Booking = 'booking',
	Giftcard = 'giftcard',
	Package = 'package',
}

export enum BillingInvoiceLineType {
	PaymentFee = 'payment_fee',
	GuaranteeFee = 'guarantee_fee',
	RoundingAdjustment = 'rounding_adjustment',
	Subscription = 'subscription',
	Sms = 'sms',
	Other = 'other',
}

export enum BillingDiscountType {
	Percent = 'percent',
	Amount = 'amount',
}

export enum BillingPackageName {
	Basic = 'basic',
	Premium = 'premium',
	Ultimate = 'ultimate',
}

export enum StripePaymentMethodType {
	Card = 'card',
	SepaDebit = 'sepa_debit',
}

export enum BillingSanctionLevel {
	Zero = 0,
	Warning = 1,
	Suspension = 2,
}

export enum GiftcardValidityMode {
	Period = 'PERIOD',
	FixedDate = 'FIXED_DATE',
}

export enum BookingEventLogStatus {
	Success = 'success',
	Failed = 'failed',
}

export enum TimingTrigger {
	StartOfBooking = 'startOfBooking',
	EndOfBooking = 'endOfBooking',
}

export enum BookingRuleMatchMode {
	All = 'all',
	Any = 'any',
	None = 'none',
}

export enum ReconfirmationStatus {
	None = 0,
	Pending = 1,
	Reconfirmed = 2,
}

export enum FeatureFlag {
	Ghost = 'ghost',
	GuaranteeAds = 'guarantee-ads',
	Giftcards = 'giftcards',
	OnlineGiftcards = 'giftcards-online',
	Payment = 'payment',
	MultiActivity = 'multi-activity',
	Reviews = 'reviews',
	PaymentDisplay = 'paymentDisplay',
	Loyalty = 'loyalty',
	MajorUpdate202610Dismissed = 'major-update-2026-10-dismissed',
}

export enum CustomFieldAppRule {
	Hidden = 'hidden',
	Readonly = 'readonly',
	Optional = 'optional',
	Mandatory = 'mandatory',
}

export enum CustomFieldWidgetRule {
	Hidden = 'hidden',
	Optional = 'optional',
	Mandatory = 'mandatory',
}

export enum CustomFieldType {
	Text = 'text',
	Number = 'number',
	Date = 'date',
	Select = 'select',
	Checkbox = 'checkbox',
	Color = 'color',
	Address = 'address',
	Country = 'country',
	Url = 'url',
	Email = 'email',
	Phone = 'phone',
	RichTextArea = 'rich_text_area',
}

export enum SurveyEmailCondition {
	Always = 'always',
	Online = 'online',
	Never = 'never',
}

export enum GuaranteeType {
	Booking = 'booking',
	Damage = 'damage',
}

export enum OfferEngineType {
	Recurrent = 'recurrent',
	Event = 'event',
}

export enum OfferSessionOrderStrategy {
	Or = 'or',
	Parallel = 'parallel',
}

export enum OpeningHourEntityType {
	Business = 'business',
	Activity = 'activity',
	Area = 'area',
	GuestPrice = 'guestPrice',
	Session = 'session',
}

export enum OpeningHourType {
	Default = 'default',
	Custom = 'custom',
	Closed = 'closed',
}

export enum OpeningHourDay {
	Monday = 'monday',
	Tuesday = 'tuesday',
	Wednesday = 'wednesday',
	Thursday = 'thursday',
	Friday = 'friday',
	Saturday = 'saturday',
	Sunday = 'sunday',
}

export enum PaymentPosMethod {
	Card = 'card',
	Cash = 'cash',
	Check = 'check',
	BankTransfer = 'bank_transfer',
	Other = 'other',
}

export enum ProductPriceBy {
	Quantity = 'quantity',
	Booking = 'booking',
	Group = 'group',
}

export enum DiscountType {
	Percentage = 'percentage',
	AmountPerPax = 'amount_per_pax',
	AmountPerBooking = 'amount_per_booking',
}

export enum UserDeviceTokenStatus {
	Valid = 'valid',
	Invalid = 'invalid',
	Unknown = 'unknown',
}

export enum ReleaseNoteReactionType {
	ThumbsUp = 'thumbs_up',
	Heart = 'heart',
	ThumbsDown = 'thumbs_down',
}

export enum ReleaseNoteType {
	New = 'new',
	Update = 'update',
	Bug = 'bug',
}

export enum SessionEngineEventLocationOverrideMode {
	Default = 'default',
	Custom = 'custom',
	None = 'none',
}

export enum SmsRefillStatus {
	Failed = 'failed',
	Pending = 'pending',
	Credited = 'credited',
	CreditCanceled = 'credit_canceled',
	Canceled = 'canceled',
}

export enum SmsRefillType {
	Manual = 'manual',
	Auto = 'auto',
}

export enum SmsType {
	BookingReminder = 'booking_reminder',
	BookingReconfirmation = 'booking_reconfirmation',
	BookingReview = 'booking_review',
	BookingEvent = 'booking_event',
}

export enum SmsReviewUrlType {
	Reservatoo = 'reservatoo',
	Google = 'google',
}

export enum StripeTransactionStatus {
	Available = 'available',
	Pending = 'pending',
}

export enum StripeTransactionType {
	Adjustment = 'adjustment',
	Advance = 'advance',
	AdvanceFunding = 'advance_funding',
	AnticipationRepayment = 'anticipation_repayment',
	ApplicationFee = 'application_fee',
	ApplicationFeeRefund = 'application_fee_refund',
	Charge = 'charge',
	ClimateOrderPurchase = 'climate_order_purchase',
	ClimateOrderRefund = 'climate_order_refund',
	ConnectCollectionTransfer = 'connect_collection_transfer',
	Contribution = 'contribution',
	IssuingAuthorizationHold = 'issuing_authorization_hold',
	IssuingAuthorizationRelease = 'issuing_authorization_release',
	IssuingDispute = 'issuing_dispute',
	IssuingTransaction = 'issuing_transaction',
	ObligationOutbound = 'obligation_outbound',
	ObligationReversalInbound = 'obligation_reversal_inbound',
	Payment = 'payment',
	PaymentFailureRefund = 'payment_failure_refund',
	PaymentNetworkReserveHold = 'payment_network_reserve_hold',
	PaymentNetworkReserveRelease = 'payment_network_reserve_release',
	PaymentRefund = 'payment_refund',
	PaymentReversal = 'payment_reversal',
	PaymentUnreconciled = 'payment_unreconciled',
	Payout = 'payout',
	PayoutCancel = 'payout_cancel',
	PayoutFailure = 'payout_failure',
	Refund = 'refund',
	RefundFailure = 'refund_failure',
	ReserveTransaction = 'reserve_transaction',
	ReservedFunds = 'reserved_funds',
	StripeFee = 'stripe_fee',
	StripeFxFee = 'stripe_fx_fee',
	TaxFee = 'tax_fee',
	Topup = 'topup',
	TopupReversal = 'topup_reversal',
	Transfer = 'transfer',
	TransferCancel = 'transfer_cancel',
	TransferFailure = 'transfer_failure',
	TransferRefund = 'transfer_refund',
}

export enum TransactionOperation {
	BookingPayment = 'booking_payment',
	BookingRefund = 'booking_refund',
	GiftcardSale = 'giftcard_sale',
	GiftcardConsumption = 'giftcard_consumption',
	GiftcardRefund = 'giftcard_refund',
	GiftcardRecredit = 'giftcard_recredit',
	GiftcardCreditExpired = 'giftcard_credit_expired',
	PackageSale = 'package_sale',
	PackageConsumption = 'package_consumption',
	PackageRefund = 'package_refund',
	PackageRecredit = 'package_recredit',
	PackageCreditExpired = 'package_credit_expired',
	Other = 'other',
}

export enum NotificationSound {
	Default = 'default',
	Chime = 'chime',
	Cashmachine = 'cashmachine',
	Coins = 'coins',
	Bell = 'bell',
	Laser = 'laser',
	Cat = 'cat',
	Down = 'down',
	Valid = 'valid',
	Fail = 'fail',
	Yay = 'yay',
	None = 'none',
}

export enum UserRole {
	User = 'USER',
	Admin = 'ADMIN',
	Super = 'SUPER',
}

export enum GiftcardOrderStatus {
	Pending = 'pending',
	Paid = 'paid',
	Canceled = 'canceled',
}

export enum WidgetAuthMode {
	None = 'none',
	Email = 'email',
	Okta = 'okta',
}

export enum CustomerPackageOrderStatus {
	Pending = 'pending',
	Paid = 'paid',
	Canceled = 'canceled',
}

export enum WidgetFlow {
	Flow1 = 'flow1',
	Flow2 = 'flow2',
	Flow3 = 'flow3',
}

export enum WidgetButtonStyle {
	Rounded = 'rounded',
	Sharp = 'sharp',
	Circle = 'circle',
}

export enum ActionTrackingSortField {
	CreatedAt = 'createdAt',
	Id = 'id',
}

export enum SortDirection {
	Asc = 'asc',
	Desc = 'desc',
}

export enum AdminB2bPaymentSortField {
	Id = 'id',
	CreatedAt = 'createdAt',
	UpdatedAt = 'updatedAt',
	Amount = 'amount',
}

export enum AdminBillingVoucherSortField {
	Id = 'id',
	Code = 'code',
	SubscriptionAmount = 'subscriptionAmount',
	ExpiresAt = 'expiresAt',
	CreatedAt = 'createdAt',
}

export enum AdminBusinessSortField {
	Name = 'name',
	NextBillingDate = 'nextBillingDate',
	NextInvoiceDate = 'nextInvoiceDate',
	Mrr = 'mrr',
	SubscriptionAmount = 'subscriptionAmount',
	Revenues = 'revenues',
	RegistrationDate = 'registration_date',
	CreatedAt = 'createdAt',
	LastBookingCreatedAt = 'lastBookingCreatedAt',
	BillingEnabled = 'billingEnabled',
}

export enum AdminEventSortField {
	Id = 'id',
	CreatedAt = 'createdAt',
}

export enum AdminLeadSortField {
	Id = 'id',
	CreatedAt = 'createdAt',
}

export enum ReleaseNoteSortField {
	PublishedAt = 'publishedAt',
	Id = 'id',
}

export enum BookingSortField {
	Date = 'date',
	CreatedAt = 'createdAt',
	UpdatedAt = 'updatedAt',
	StartTime = 'startTime',
	Status = 'status',
	Id = 'id',
}

export enum CustomerSortField {
	TotalSpent = 'totalSpent',
	Lastname = 'lastname',
	Firstname = 'firstname',
	BookingCount = 'bookingCount',
	LastBookingDate = 'lastBookingDate',
	FirstBookingDate = 'firstBookingDate',
	CreatedAt = 'createdAt',
	Id = 'customer_id',
}

export enum ReviewSortField {
	CreatedAt = 'createdAt',
	Rating = 'rating',
	AnsweredAt = 'answeredAt',
	IsRead = 'isRead',
	Date = 'date',
}

export enum SessionInstanceSortField {
	Date = 'date',
	Start = 'start',
	End = 'end',
	Id = 'id',
}

export enum BlockingPeriodSortField {
	Date = 'date',
	Id = 'id',
}

export enum EmailSentSortField {
	DateSent = 'dateSent',
	Id = 'id',
}

export enum OpeningHourExceptionSortField {
	StartDate = 'start_date',
	EndDate = 'end_date',
	Id = 'id',
}

export enum SmsSentSortField {
	SentAt = 'sentAt',
	Id = 'id',
}

export enum DashboardStatsGroupBy {
	Day = 'day',
	Week = 'week',
	Month = 'month',
}

export enum GiftcardSortField {
	CreatedAt = 'createdAt',
	ExpiresAt = 'expires_at',
	RemainingAmount = 'remaining_amount',
	InitialAmount = 'initial_amount',
	Code = 'code',
}

export enum NotificationSortField {
	CreatedAt = 'createdAt',
	Id = 'id',
}

export enum UserDeviceType {
	UnknownToken = 'unknown_token',
	Mobile = 'mobile',
	Tablet = 'tablet',
	Desktop = 'desktop',
}
